// import { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import "../styles/HeroBanner.css";

// const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;
// const IMAGE_BASE = "https://afrogebeya.com/uploads/products";
// const PLACEHOLDER = "https://via.placeholder.com/500x500?text=Afrogebeya";
// const PRODUCTS_PER_SLIDE = 6;

// const resolveImage = (url) =>
//   url ? `${IMAGE_BASE}/${url.replace(/\\/g, "/")}` : PLACEHOLDER;

// const createSlug = (name = "", id) =>
//   `${name
//     .toLowerCase()
//     .replace(/[^a-z0-9]+/g, "-")
//     .replace(/(^-|-$)/g, "")}-${id}`;

// export default function HeroBanner() {
//   const navigate = useNavigate();
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchHeroProducts = async () => {
//       try {
//         setLoading(true);
//         setError("");
//         const res = await axios.get(`${PRODUCT_API}/products/buyers`, {
//           params: { page: 0, size: 30 },
//         });
//         setProducts(res.data?.content || []);
//       } catch (err) {
//         console.error("Failed to fetch hero products", err);
//         setError("Unable to load featured products. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchHeroProducts();
//   }, []);

//   const groupedProducts = useMemo(() => {
//     const groups = [];
//     for (let i = 0; i < products.length; i += PRODUCTS_PER_SLIDE) {
//       groups.push(products.slice(i, i + PRODUCTS_PER_SLIDE));
//     }
//     return groups;
//   }, [products]);

//   if (loading) {
//     return (
//       <section className="hero-wrapper">
//         <div className="hero-loading">
//           {Array.from({ length: PRODUCTS_PER_SLIDE }).map((_, i) => (
//             <div key={i} className="hero-skeleton-card" />
//           ))}
//         </div>
//       </section>
//     );
//   }

//   if (error) {
//     return (
//       <section className="hero-wrapper">
//         <div className="alert alert-warning text-center">{error}</div>
//       </section>
//     );
//   }

//   if (!groupedProducts.length) return null;

//   return (
//     <section className="hero-wrapper">
//       <div
//         id="homeHeroCarousel"
//         className="carousel slide home-hero-carousel"
//         data-bs-ride="carousel"
//         data-bs-interval="5000"
//         aria-label="Featured products carousel"
//       >
//         {/* Indicators */}
//         <div className="carousel-indicators">
//           {groupedProducts.map((_, index) => (
//             <button
//               key={index}
//               type="button"
//               data-bs-target="#homeHeroCarousel"
//               data-bs-slide-to={index}
//               className={index === 0 ? "active" : ""}
//               aria-current={index === 0 ? "true" : undefined}
//               aria-label={`Slide ${index + 1}`}
//             />
//           ))}
//         </div>

//         {/* Slides */}
//         <div className="carousel-inner">
//           {groupedProducts.map((slideProducts, slideIndex) => (
//             <div
//               key={slideIndex}
//               className={`carousel-item ${slideIndex === 0 ? "active" : ""}`}
//             >
//               <div className="home-hero-slide">
//                 <div className="hero-products-grid">
//                   {slideProducts.map((product) => (
//                     <div
//                       key={product.id}
//                       className="hero-product-card"
//                       onClick={() => {
//                         // Analytics hook
//                         console.log("HeroBanner click:", product.id);
//                         navigate(
//                           `/products/${createSlug(product.productName, product.id)}`,
//                         );
//                       }}
//                     >
//                       <div className="hero-product-image-wrapper">
//                         <img
//                           src={resolveImage(product.mainImageUrl)}
//                           alt={product.productName}
//                           className="hero-product-image"
//                           loading="lazy"
//                           onError={(e) => (e.target.src = PLACEHOLDER)}
//                         />
//                       </div>
//                       <div className="hero-product-info">
//                         <h6>{product.productName}</h6>
//                         {product.price && (
//                           <span className="hero-product-price">
//                             {new Intl.NumberFormat("en-US", {
//                               style: "currency",
//                               currency: product.currency,
//                             }).format(product.price)}
//                           </span>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Controls */}
//         <button
//           className="carousel-control-prev"
//           type="button"
//           data-bs-target="#homeHeroCarousel"
//           data-bs-slide="prev"
//           aria-label="Previous slide"
//         >
//           <span className="carousel-control-prev-icon" />
//         </button>
//         <button
//           className="carousel-control-next"
//           type="button"
//           data-bs-target="#homeHeroCarousel"
//           data-bs-slide="next"
//           aria-label="Next slide"
//         >
//           <span className="carousel-control-next-icon" />
//         </button>
//       </div>
//     </section>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "../styles/HeroBanner.css";

import PLACEHOLDER from "../../src/assets/images/logo192.png";

const PRODUCT_API = process.env.REACT_APP_PRODUCT_SERVICE_URL;

const IMAGE_BASE = "https://afrogebeya.com/uploads/products";
// const PLACEHOLDER = "..";

const resolveImage = (url) => {
  if (!url) return PLACEHOLDER;

  return `${IMAGE_BASE}/${url.replace(/\\/g, "/")}`;
};

const createSlug = (name = "", id) =>
  `${name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")}-${id}`;

export default function HeroBanner() {
  const [itemsPerSlide, setItemsPerSlide] = useState(5);
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  useEffect(() => {
    const fetchHeroProducts = async () => {
      try {
        setLoading(true);

        const response = await axios.get(`${PRODUCT_API}/products/buyers`, {
          params: {
            page: 0,
            size: 25,
          },
        });

        setProducts(response.data?.content || []);
      } catch (error) {
        console.error("Hero products loading failed", error);

        setError("Unable to load featured products");
      } finally {
        setLoading(false);
      }
    };

    fetchHeroProducts();
  }, []);

  useEffect(() => {
    const updateSize = () => {
      if (window.innerWidth < 480) setItemsPerSlide(2);
      else if (window.innerWidth < 992) setItemsPerSlide(2);
      else setItemsPerSlide(5);
    };
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const groupedProducts = useMemo(() => {
    const groups = [];
    for (let i = 0; i < products.length; i += itemsPerSlide) {
      groups.push(products.slice(i, i + itemsPerSlide));
    }
    return groups;
  }, [products, itemsPerSlide]);

  if (loading) {
    return (
      <section className="hero-wrapper">
        <div className="hero-loading">
          {Array.from({
            length: itemsPerSlide,
          }).map((_, index) => (
            <div key={index} className="hero-skeleton-card" />
          ))}
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="hero-wrapper">
        <div className="alert alert-warning text-center">{error}</div>
      </section>
    );
  }

  if (groupedProducts.length === 0) {
    return null;
  }

  return (
    <section className="hero-wrapper">
      <div
        id="homeHeroCarousel"
        className="carousel slide home-hero-carousel"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        {/* Indicators */}

        <div className="carousel-indicators">
          {groupedProducts.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#homeHeroCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
            />
          ))}
        </div>

        {/* Slides */}

        <div className="carousel-inner">
          {groupedProducts.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div className="home-hero-slide">
                <div className="hero-products-grid">
                  {slide.map((product) => (
                    <div
                      key={product.id}
                      className="hero-product-card"
                      onClick={() => {
                        navigate(
                          `/products/${createSlug(
                            product.productName,
                            product.id,
                          )}`,
                        );
                      }}
                    >
                      <div className="hero-product-image-wrapper">
                        <img
                          src={resolveImage(product.mainImageUrl)}
                          alt={product.productName}
                          className="hero-product-image"
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.src = PLACEHOLDER;
                          }}
                        />
                      </div>

                      <div className="hero-product-info">
                        <h6>{product.productName}</h6>
                        {product.price !== null &&
                          product.price !== undefined && (
                            <span className="hero-product-price">
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: product.currency || "ETB",
                              }).format(product.price)}
                            </span>
                          )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#homeHeroCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" />
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#homeHeroCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" />
        </button>
      </div>
    </section>
  );
}
